import * as React from 'react';
import { cn } from '@frontend/shadcn/lib/utils';

const PerformanceHeader = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex justify-between items-center mr-2', className)} {...props} />
  ),
);
PerformanceHeader.displayName = 'PerformanceHeader';

const PerformanceTitle = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, children, ...props }, ref) => (
    <h3 ref={ref} className={cn('text-sm font-medium mb-0', className)} {...props}>
      {children}
    </h3>
  ),
);
PerformanceTitle.displayName = 'PerformanceTitle';

const PerformanceDateRange = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('relative text-sm text-gray-600', className)} {...props} />
  ),
);
PerformanceDateRange.displayName = 'PerformanceDateRange';

export { PerformanceHeader, PerformanceTitle, PerformanceDateRange };
